import { render, staticRenderFns } from "./NameMgt.vue?vue&type=template&id=33014aa0&"
import script from "./NameMgt.vue?vue&type=script&lang=js&"
export * from "./NameMgt.vue?vue&type=script&lang=js&"
import style0 from "./NameMgt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports